<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="saveRole"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-md-12">
        <w-input :model="$schema.name" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/role.schema';

const emptyData = () => ({ name: '', parentId: null });

// @vuese
// Modal ról
// @group Modals
export default {
  name: 'RoleModal',
  mixins: [manageMixin('role', {}, emptyData)],
  props: {
    // Id rodzica roli
    parentId: {
      required: false,
      type: Number,
      default: undefined
    }
  },
  schema,
  computed: {
    title() {
      return this.id ? 'Edycja roli' : 'Dodawanie roli';
    }
  },
  methods: {
    // @vuese
    // Zapisuje rolę
    saveRole() {
      this.$schema.parentId.$model = this.parentId;
      this.save();
    }
  }
};
</script>